import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PoAutoPage } from './po-auto.page';

const routes: Routes = [
  {
    path: '',
    component: PoAutoPage
  },
  {
    path: 'po-auto-create',
    loadChildren: () => import('./po-auto-create/po-auto-create.module').then( m => m.PoAutoCreatePageModule)
  },
  {
    path: 'po-auto-setting',
    loadChildren: () => import('./po-auto-setting/po-auto-setting.module').then( m => m.PoAutoSettingPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PoAutoPageRoutingModule {}
